<ion-header class="ion-no-border">
    <ion-toolbar>
      <ion-title color="tertiary" *ngIf="title">{{ title }}</ion-title>
      <ion-buttons slot="end">
        <ion-button fill="clear" *ngIf="!hideCloseButton" (click)="close()">
          <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
      </ion-buttons>  
    </ion-toolbar>
</ion-header>
<ion-content [scrollY]="false">
    <!-- <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button (click)="close()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        </ion-buttons>  
      </ion-toolbar> -->
    <div #container class="ion-padding">
        <ng-content></ng-content>
    </div>
</ion-content>
<ion-footer collapse="fade">
<ion-toolbar>
  <ion-buttons slot="start">
    <ion-button *ngIf="!hideBackButton" fill="clear" (click)="backAction()">
      <ion-icon color="tertiary" slot="icon-only" name="chevron-back-circle-outline"></ion-icon>
    </ion-button>
  </ion-buttons>
  <ion-title size="small" color="tertiary" *ngIf="pagination && pagination.current">{{ pagination.current + "/" + pagination.total }}</ion-title>
  <ion-buttons slot="end">
    <ion-button *ngIf="!hideForwardButton" fill="clear" (click)="nextAction()">
      <ion-icon color="tertiary" slot="icon-only" name="chevron-forward-circle-outline"></ion-icon>
    </ion-button>
  </ion-buttons>
</ion-toolbar>
</ion-footer>